import Point from "./point";

export default class Geometry {
    
    x: number;
    y: number;
    points: Point[];
    offset: Point;
    width: number;
    height: number;
    sourcePoint: Point | null;
    targetPoint: Point | null;
    constructor(width: number, height: number, x: number, y: number) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        this.offset = new Point(0, 0);
        this.points = [];
        this.sourcePoint = null;
        this.targetPoint = null;
    }
    
    getHeight(): any {
        return this.height;
    }
    getWidth(): any {
        return this.width;
    }

    getY(): number {
        return this.x;
    }
    getX(): number {
        return this.y;
    }
    setY(arg0: number): void {
        this.y = arg0;
    }
    setX(arg0: number): any {
        this.x = arg0;
    }
    isRelative(): boolean {
        return true;
    }

    translate(dx: number, dy: number): any {
        // Translates the geometry
		if (!this.isRelative())
		{
			this.x += dx;
			this.y += dy;
		}

		// Translates the source point
		if (this.sourcePoint != null)
		{
			this.sourcePoint.setX(this.sourcePoint.getX() + dx);
			this.sourcePoint.setY(this.sourcePoint.getY() + dy);
		}

		// Translates the target point
		if (this.targetPoint != null)
		{
			this.targetPoint.setX(this.targetPoint.getX() + dx);
			this.targetPoint.setY(this.targetPoint.getY() + dy);
		}

		// Translate the control points
		if (this.points != null)
		{
			const count = this.points.length;

			for (let i = 0; i < count; i++)
			{
				const pt = this.points[i];

				pt.setX(pt.getX() + dx);
				pt.setY(pt.getY() + dy);
			}
		}
    }
    
    clone(): Geometry {
        return new Geometry(this.width, this.height, this.x,this.y);
    }

    setPoints(arg0: null): any {
        this.points = [];
    }
    getPoints(): Point[] {
        return this.points;
    }
    getOffset(): Point {
        return this.offset;
    }
    setOffset(arg0: Point): void {
        this.offset = arg0;
    }
    
}